// The note inputs an approver may change; options are fetched, never carried.
import { z } from 'zod';

import { compactCardSchema } from '@apps/web/features/phoebe_chat_v3/model/shift_write_card';

export const EHR_NOTE_METHODS = [
    'phone',
    'email',
    'in_person',
    'other',
] as const;

export const ehrPersonNoteEditorSchema = z
    .object({
        kind: z.literal('ehr_person_note'),
        entity: z.enum(['clients', 'caregivers']),
        id: z.uuid(),
        note_date: z.iso.date(),
        method: z.enum(EHR_NOTE_METHODS),
        tag_ids: z.array(z.string().min(1)),
        people: z.array(
            z.object({ id: z.uuid(), name: z.string().min(1) }).strict(),
        ),
        body: z.string().min(1),
        card: compactCardSchema,
    })
    .strict();

export type EhrPersonNoteEditor = z.infer<typeof ehrPersonNoteEditorSchema>;
